
@if (!confirmationModalData) {
  <h1 mat-dialog-title>{{'deletePopupLabels.heading' | translate}}</h1>
  <div mat-dialog-content>{{'deletePopupLabels.deleteConfirmation' | translate}}</div>
  <div mat-dialog-actions>
    <button id="confirmModelCmp_cancelBtn" mat-flat-button color="warn" type="button" (click)="close(false)">{{'cancelButtonLabel' | translate}}</button>
    <button id="confirmModelCmp_submitBtn" mat-flat-button color="primary" type="button" (click)="close(true)">{{'okayLabel' | translate}}</button>
  </div>
}

@if (confirmationModalData) {
  <span class="font-extrabold" mat-dialog-title>{{confirmationModalData.heading}}</span>
  @if (confirmationModalData.deleteConfirmation.length) {
    <div class="max-h-100 overflow-auto">
      @for (item of confirmationModalData.deleteConfirmation; track item) {
        <div>
          <div mat-dialog-content class="py-3">{{ item }}</div>
        </div>
      }
    </div>
  } @else {
    <div mat-dialog-content>{{confirmationModalData.deleteConfirmation}}</div>
  }
  <div mat-dialog-actions>
    <div class="flex items-center w-full mx-2">
      <button class="w-2/4 submitButton focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" id="confirmModelCmp_submitBtn" mat-flat-button type="button" (click)="close(true)">{{confirmationModalData.submitButtonLabel}}</button>
      <button class="w-2/4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" id="confirmModelCmp_cancelBtn" mat-flat-button color="primary" type="button" (click)="close(false)">{{confirmationModalData.cancelButtonLabel}}</button>
    </div>
  </div>
}